export const getActiveContentDateRange = () => ({
  startDate: '2000-01-01T00:00:00.000Z',
  endDate: new Date(new Date().setFullYear(new Date().getFullYear() + 10)).toISOString()
});
